import { connect as withFormik } from 'formik'
import { get, isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { fetchTargetingAggregateSuggestions, fetchTargetingRuleSetSuggestions } from '@/components/Publisher/actions'
import {
  FETCH_TARGETING_AGGREGATE_SUGGESTIONS,
  FETCH_TARGETING_RULE_SET_SUGGESTIONS
} from '@/components/Publisher/actionTypes'
import {
  makeGetTargetingAggregateSuggestions,
  makeGetTargetingRuleSetSuggestions
} from '@/components/Publisher/selectors'
import { fetchAttributes } from '@/pages/OrganizationUserAttributesPage/actions'
import { FETCH_ATTRIBUTES } from '@/pages/OrganizationUserAttributesPage/actionTypes'
import * as actions from '@/pages/SpaceChatbotKnowledgeHubPage/actions'
import { resetRequest } from '@/store/actions'
import { isRequestPending } from '@/store/selectors'
import { getTargetingAggregateAttributes, getTargetingRuleSetAttributes } from '@/utilities/UserUtilities/selectors'

import './index.scss'

import AudienceTargeting from '@/components/Form/AudienceTargeting'
import { convertAudienceValue } from '@/utilities/AudienceTarget/convertAudienceValue'

class AudienceFields extends Component<any, any> {
  static displayName = 'AudienceFields'

  static propTypes = {
    targetingAggregates: PropTypes.arrayOf(PropTypes.object).isRequired
  }

  componentDidMount() {
    this.props.actions.resetRequest([FETCH_ATTRIBUTES])
    this.props.actions.fetchAttributes()
  }

  componentDidUpdate() {
    // If the audience value is using the old audience data structure,
    // convert it to the new structure that is expected by the audience targeting component
    if (
      !isEmpty(this.props.targetingAggregates) &&
      get(this.props.formik.values.currentMicroapp.audience[0], 'audienceFilter') &&
      !isEmpty(this.props.formik.values.currentMicroapp.audience[0].audienceFilter[0].audienceType)
    ) {
      const convertedAudienceValue = convertAudienceValue(
        this.props.formik.values.currentMicroapp.audience,
        this.props.targetingAggregates
      )

      // Overwrite the old audience format with the new one
      this.props.formik.setFieldValue('currentMicroapp.audience', convertedAudienceValue)
    }
  }

  render() {
    // Don't render the component unless the audience target section is expanded,
    // or until after the audience data format has been converted from the old one to the new one
    if (
      !this.props.formik.values.isAudienceTargetingExpanded ||
      get(this.props.formik.values.currentMicroapp.audience[0], 'audienceFilter')
    ) {
      return null
    } else {
      return (
        <AudienceTargeting
          name="currentMicroapp.audience"
          title={this.props.formik.values.currentMicroapp.title}
          startWithAudience={true}
          firstFilterMandatory={true}
        />
      )
    }
  }
}

export { /** @deprecated */ AudienceFields }

function mapStateToProps(state: any, ownProps: any) {
  const getTargetingRuleSetSuggestions = makeGetTargetingRuleSetSuggestions()
  const getTargetingAggregateSuggestions = makeGetTargetingAggregateSuggestions()
  return {
    targetingAggregates: ownProps.targetingAggregates || getTargetingAggregateAttributes(state),
    ruleResults: ownProps.ruleResults || getTargetingRuleSetSuggestions(state),
    suggestionResults: ownProps.suggestionResults || getTargetingAggregateSuggestions(state),
    targetingRuleSets: ownProps.targetingRuleSets || getTargetingRuleSetAttributes(state),
    isLoading: isRequestPending(state, [
      FETCH_ATTRIBUTES,
      FETCH_TARGETING_AGGREGATE_SUGGESTIONS,
      FETCH_TARGETING_RULE_SET_SUGGESTIONS
    ])
  }
}

function mapDispatchToProps(dispatch: any) {
  return {
    actions: bindActionCreators(
      {
        fetchAttributes,
        fetchTargetingAggregateSuggestions,
        fetchTargetingRuleSetSuggestions,
        resetRequest,
        ...actions
      },
      dispatch
    )
  }
}

export default withFormik(connect(mapStateToProps, mapDispatchToProps)(AudienceFields))
